import { EMAIL_COMPOSER_ROW_LABEL_WIDTH } from '@/components/email-composer/email-composer-layout';
import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface RecipientFilterSummaryProps {
  /** Number of affiliates matching the current filter. */
  count: number;
  /** Frozen gift selections are not a filter cohort. */
  summaryKey?: string;
}

/**
 * Read-only recipient row shown when the send targets "all affiliates matching
 * the filter". The cohort is resolved server-side, so there are no individual
 * recipient tags to edit — just the count.
 */
const RecipientFilterSummary: React.FC<RecipientFilterSummaryProps> = ({
  count,
  summaryKey = 'affiliates.selectAll.recipientSummary',
}) => {
  const { t } = useTranslation();

  return (
    <Flex align="center" gap={2} minH="28px">
      <Text fontSize="sm" color="fg.muted" w={EMAIL_COMPOSER_ROW_LABEL_WIDTH} flexShrink={0}>
        {t('bulkEmail.compose.to')}:
      </Text>
      <Text fontSize="sm" fontWeight="medium">
        {t(summaryKey, { count })}
      </Text>
    </Flex>
  );
};

export default RecipientFilterSummary;
